<template>
    <layout-gestao>
        <div class="row">
            <div class="col-sm-12">
                <table-data
                    :route="url.getList"
                    tableClass="table-responsive-sm"
                    :settings="table.settings"
                    :columns="table.columns"
                    :inlineFilters="table.filters"
                    :autoUpdateFilter="table.autoUpdateFilter"
                    :addParamsToUrl="table.addParamsToUrl"
                    :loadingMsg="table.loadingMsg"
                    :notFoundMsg="table.notFoundMsg"
                    :orderByTemplate="table.orderByTemplate"
                    @error-load="showError"
                >
                    <template v-slot:filters="{ tableFilters, search }">
                        <form autocomplete="false" @submit.prevent="" @keyup.enter="search">
                            <div class="row header">
                                <div class="col-12">
                                    <header-list
                                        :title="pageTitle"
                                        :placeholderSearch="searchPlaceholder"
                                        v-model="tableFilters.q"
                                        :routeAddName="`${moduleCode}.${pageID}.create`"
                                        :canAdd="canAdd"
                                        :addTitle="addTitle"
                                    />
                                </div>
                            </div>
                        </form>
                    </template>

                    <template v-slot:beforeTable="{ tableFilters }" v-if="!isSingleLocale">
                        <div class="row" v-if="filterLocale.length">
                            <div class="col-md-6">
                                <div class="row no-gutters form-group btn-group-toggle-city main">
                                  <div :class="'col-'+ (12/filterLocale.length)" :for="'action-'+item.id" v-for="(item, index) in filterLocale" :key="index">
                                    <label class="btn btn-sm btn-block z-depth-0" :class="{'active': item.code == tableFilters.locale}">
                                        <input type="radio" name="toogle-action" :id="'action-'+item.id" :value="item.code" v-model="tableFilters.locale" autocomplete="off"> <span class="">{{ item.name }}</span>
                                    </label>
                                  </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:body="{row, index, remove}">
                        <td :class="table.columns[0].class">{{ columnValue(row, table.columns[0]) }}</td>
                        <td :class="table.columns[1].class">{{ columnValue(row, table.columns[1]) }}</td>
                        <td :class="table.columns[2].class">{{ columnValue(row, table.columns[2]) }}</td>
                        <column-actions v-if="checkActions"
                            :routeEdit="`${moduleCode}.${pageID}.show`"
                            @delete="deleteItem"
                            :canDetail="canDetail"
                            :canEdit="canEdit"
                            :canDelete="canDelete"
                            :row="row"
                            :index="index"
                            :callbackDelete="remove" />
                    </template>
                </table-data>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
    import GeneralMixin from '../../mixin'

    export default {
        mixins: [GeneralMixin],
        data() {
            let pageID = 'news_categories';
            return {
                pageID: pageID,
                table: {
                    columns: [
                        {
                            label: `${pageID}.list.name`,
                            field:  'name',
                            class: '',
                            sortable: true,
                        },
                        {
                            label: `${pageID}.list.slug`,
                            field:  'slug',
                            class: '',
                            sortable: false,
                        },
                        {
                            label: `${pageID}.list.description`,
                            field:  'description',
                            class: '',
                            sortable: false,
                        },
                        {
                            label: '',
                            field:  null,
                            sortable: false,
                            class: 'actions',
                        }
                    ],
                    filters: {
                        q: '',
                        locale: '',
                    }
                },
            }
        },
        beforeMount() {
            if(this.isSingleLocale) {
                this.table.filters.locale = this.defaultLocale ? this.defaultLocale.code : null;
            }
        },
    }
</script>
